var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvidenceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66658 12H9.67405M12.9962 12H13.0036M16.3258 12H16.3332M18 19.5C19.0268 19.5 19.8591 18.5406 19.8591 17.3572C19.8591 15.484 19.776 14.2387 21.061 12.7576C21.424 12.3392 21.424 11.6608 21.061 11.2424C19.776 9.76129 19.8591 8.51597 19.8591 6.64286C19.8591 5.45939 19.0268 4.5 18 4.5M7.99996 19.5C6.97316 19.5 6.14077 18.5406 6.14077 17.3572C6.14077 15.484 6.22393 14.2387 4.9389 12.7576C4.57587 12.3392 4.57587 11.6608 4.9389 11.2424C6.19576 9.79376 6.14077 8.53327 6.14077 6.64286C6.14077 5.45939 6.97316 4.5 7.99996 4.5",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidenceIcon);
export default __webpack_public_path__ + "static/media/evidence_icon.ac715cf2d312155ef3e4a18bb3601d03.svg";
export { ForwardRef as ReactComponent };